import { ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteReasonRemarkComponent } from 'src/app/Account/delete-reason-remark/delete-reason-remark.component';
import { ALERT_TYPE } from 'src/app/constants';
import { ReceiptDetailsComponent } from 'src/app/Sets/receipt-details/receipt-details.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Customer } from 'src/model/customer.model';
import { Profile } from 'src/model/profile.model';
import { ReserveGroup } from 'src/model/reserveGroup.model';
import { Transaction } from 'src/model/transaction.model';
import { ReserveGroupService } from 'src/services/reserve-group.service';
import { TransactionService } from 'src/services/transaction.service';
import { AddReserveGroupComponent } from '../add-reserve-group/add-reserve-group.component';
import { ViewReserveGroupsComponent } from '../view-reserve-groups/view-reserve-groups.component';

@Component({
    selector: 'app-reserve-history',
    templateUrl: './reserve-history.component.html',
    styleUrls: ['./reserve-history.component.scss'],
    standalone: false
})
export class ReserveHistoryComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private cdr = inject(ChangeDetectorRef);
  protected enums = inject(Enums);
  private reserveGroupService = inject(ReserveGroupService);
  private transactionService = inject(TransactionService);

  reserveList: Transaction[] = [];

  isDirty = false;

  @Input() totalReserveAmount: number;
  // @Input() selectedCustomerID: number;
  @Input() selectedProfileID: number;
  @Input() selectedProfile: Profile;

  @Input() profileList: Profile[];

  @Input() viewCustomer: Customer;

  @Input() sharedProfileId: number;

  reserveGroupList: ReserveGroup[] = [];

  ngOnInit(): void {
    this.getAllTransactionsOfReserve();
    if (this.sharedProfileId !== undefined) this.getAllProfileReserveGroups();
  }

  async getAllTransactionsOfReserve() {
    this.reserveList = await this.transactionService.getProfileReserveReceipts(this.selectedProfileID);
  }

  calculateTotalReserve(reserve: Transaction[]) {
    let sumOfReserve = 0;
    for (let i = 0; i < reserve.length; i++) {
      sumOfReserve += reserve[i].Amount;
    }
    return sumOfReserve;
  }

  checkAmountInOut(amount: number) {
    if (amount < 0)
      return 'negative';
    else
      return 'positive';
  }

  confirmDeleteTranscation(reserve: Transaction) {
    const timeDiff = new Date().getTime() - new Date(reserve.Date).getTime();
    const dateDiff = timeDiff / (1000 * 3600 * 24);
    if (dateDiff < 90 || this.sharedService.isBossAccount() == true) {
      const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
      modalRef.componentInstance.message = "Are you sure you want to delete SIMPAN RM " + reserve.Amount + "?";
      modalRef.result.then((confirm) => {
        if (confirm) {
          const modalRef = this.sharedService.openModal(DeleteReasonRemarkComponent);
          modalRef.componentInstance.transaction = reserve;
          modalRef.componentInstance.passEntry.subscribe((entry) => {
            const remark = entry;

            //append added account to account list
            this.deleteTransaction(remark, reserve.ID);
          });
        }
      });
    }
    else
      this.sharedService.openAlert("This transaction is too old, please contact your admin to delete", ALERT_TYPE.DANGER)
  }

  async deleteTransaction(remark: string, transactionID: number) {
    await this.transactionService.deleteReserveTransaction(transactionID, remark)
    this.removeTransctionFromList(transactionID);
    this.isDirty = true;
  }

  removeTransctionFromList(transactionId: number) {
    for (let i = 0; i < this.reserveList.length; i++) {
      if (Number(this.reserveList[i].ID) == transactionId) {
        this.reserveList.splice(i, 1);
        this.cdr.detectChanges();

        if (this.reserveList.length == 0)
          window.location.reload();
      }
    }
    return -1
  }

  reset() {
    if (this.isDirty == true)
      window.location.reload();
    else
      this.activeModal.close();
  }

  openReserveGroupModal() {
    const modalRef = this.sharedService.openModal(AddReserveGroupComponent, "regularModal");
    modalRef.componentInstance.sharedProfileId = this.sharedProfileId;
    modalRef.componentInstance.selectedProfileId = this.selectedProfileID;
  }

  async getAllProfileReserveGroups() {
    this.reserveGroupList = await this.reserveGroupService.getAllProfileReserveGroups(this.selectedProfileID);
  }

  openReserveGroupDetailsModal(rgID: number) {
    const modalRef = this.sharedService.openModal(ViewReserveGroupsComponent, "regularModal");
    modalRef.componentInstance.reserveGroupId = rgID;
  }

  openDeleteReserveGroupDialog(rg: ReserveGroup) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to delete SIMPAN GROUP  " + rg.ID + "?";
    modalRef.result.then((confirm) => {
      if (confirm)
        this.deleteReserveGroup(rg.ID);
    });
  }

  openSetDialog(setId: number) {
    const modalRef = this.sharedService.openModal(ReceiptDetailsComponent);
    modalRef.componentInstance.receiptId = setId;
    modalRef.componentInstance.isModal = true;
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      window.location.reload();
    });
  }

  async deleteReserveGroup(id: number) {
    await this.reserveGroupService.deleteReserveGroup(id)
    window.location.reload();
  }
}
